import { useNavigate, useParams } from 'react-router-dom';
import StepWizard from '../../../commons/StepWizard/StepWizard';
import { StepWizardStep } from '../../../commons/StepWizard/StepWizard.types';
import ForgotPasswordForm from './ForgotPasswordForm/ForgotPasswordForm';
import { useEffect, useMemo } from 'react';
import { UserRoles } from '../../../../types/models/user/user.types';
import NewPasswordForm from './NewPasswordForm/NewPasswordForm';
import { useForgotPasswordData } from '../../../../hooks/fetchers/useForgotPasswordData/useForgotPasswordData';

export default () => {
  const { role, hash } = useParams<{ role: UserRoles; hash: string }>();

  const navigate = useNavigate();

  // @ts-ignore // isInitialLoading isn't recongnized by Typescript but exists
  const { data, isInitialLoading, isError } = useForgotPasswordData({ role, hash });

  useEffect(() => {
    if (isError) {
      navigate('/');
    }
  }, [isError]);

  const steps: StepWizardStep[] = useMemo(
    () => [
      {
        step: 1,
        component: ForgotPasswordForm,
        title:
          role === UserRoles.Entreprise
            ? 'Mot de passe <secondary>oublié</secondary>'
            : 'Mot de passe <primary>oublié</primary>',
        subtitle: 'Renseignez votre adresse email',
        backDisabled: true,
      },
      {
        step: 2,
        component: NewPasswordForm,
        title:
          role === UserRoles.Entreprise
            ? 'Nouveau <secondary>mot de passe</secondary>'
            : 'Nouveau <primary>mot de passe</primary>',
        subtitle: 'Renseignez votre nouveau mot de passe',
        hidden: !hash,
      },
    ],
    [role, hash]
  );

  if (isInitialLoading) return <p>Chargement...</p>;

  return (
    <StepWizard
      {...{ steps }}
      defaultStep={data ? 2 : 1}
      isCompany={role === UserRoles.Entreprise}
    />
  );
};
